import FilterDrawer from 'components/Feedback/FilterDrawer';
import { useApp } from 'contexts/app';
import { useViewport } from 'contexts/viewport';
import ErrorPage from 'pages/Error/404';
import { PageContext } from 'pages/InstructorAssignmentFeedback/PageProvider';
import Desktop from 'pages/InstructorAssignmentFeedback/desktop';
import Mobile from 'pages/InstructorAssignmentFeedback/mobile';
import Tablet from 'pages/InstructorAssignmentFeedback/tablet';
import { useContext } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Loading } from 'shell/components';
import { getUserPreferredFullName } from 'utils/helper';

const PageLayout = () => {
    const { isLoading, studentAccountUsers, assignments, currentAssignmentId, currentAssignment, feedback } = useApp();
    const history = useHistory();
    const { device } = useViewport();
    const params = useParams();

    const { filters, setFilters, resetFilters } = useContext(PageContext);

    const getFilterCount = (filters) => {
        let count = 0;
        if (filters.sort !== 'namea-z') count++;
        return count;
    };

    const onClickBack = () => {
        history.push(`/assignments/${currentAssignmentId}`);
    };

    const onClickView = ({ id }) => {
        history.push(`/assignments/${currentAssignmentId}/feedback/${id}`);
    };

    const onClickViewAll = () => {
        const firstStudent = studentAccountUsers
            .filter((accountUser) => {
                return feedback.some(({ owner_account_id }) => owner_account_id === accountUser.owner_account_id);
            })
            .sort((a, b) => {
                const aName = getUserPreferredFullName(a).toLowerCase();
                const bName = getUserPreferredFullName(b).toLowerCase();
                if (aName < bName) return -1;
                if (aName > bName) return 1;
                return 0;
            })[0];
        const feedbackItems = feedback
            .filter(({ owner_account_id }) => {
                return owner_account_id === firstStudent.owner_account_id;
            })
            .sort((a, b) => {
                return b.created_on - a.created_on;
            });
        history.push(`/assignments/${currentAssignmentId}/feedback/${feedbackItems[0].id}`);
    };

    const props = {
        filters,
        setFilters,
        getFilterCount,
        onClickBack,
        onClickView,
        onClickViewAll,
    };

    const renderResponsiveLayout = (device) => {
        return {
            mobile: <Mobile {...props} />,
            tablet: <Tablet {...props} />,
            desktop: <Desktop {...props} />,
        }[device];
    };

    if (isLoading || currentAssignmentId !== params.id || !feedback) return <Loading />;

    if (assignments && !currentAssignment) return <ErrorPage />;

    return (
        <>
            {renderResponsiveLayout(device)}
            <FilterDrawer filters={filters} setFilters={setFilters} resetFilters={resetFilters} />
        </>
    );
};

export default PageLayout;
